import React from "react";

const CartSidebar = ({ open, onClose, items }) => {
    return (
        <div className={`cart-sidebar ${open ? "open" : ""}`}>
            <div className="cart-sidebar-header">
                <h3>Your Cart</h3>
                <button onClick={onClose} className="close-btn">×</button>
            </div>
            <div className="cart-sidebar-body">
                {items.length === 0 ? (
                    <p>Your cart is empty.</p>
                ) : (
                    items.map((item) => (
                        <div key={item.id} className="cart-item">
                            <h4>{item.name}</h4>
                            <p>${item.price.toFixed(2)}</p>
                            {item.duration && <p>Duration: {item.duration}</p>}
                        </div>
                    ))
                )}
            </div>
            <div className="cart-sidebar-footer">
                <button onClick={() => window.location.href = "/checkout"} className="checkout-button">
                    Proceed to Checkout
                </button>
            </div>
        </div>
    );
};

export default CartSidebar;
